module.exports = __webpack_public_path__ + "static/media/trend.6798fabb.svg";